<template>
  <div class="container page">
    <van-nav-bar :title="$t('分数')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right v-if="false">
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{ $t("withdraw.record") }}</span>
      </template>
    </van-nav-bar>
    <div style="width:100%;overflow: auto;">

      <div class="loginForm">

        <div class="label" style="margin-top: 30px">{{ $t("银行兑换") }}</div>
        <div class="van-cell van-field"  @click="showBank = true" >
          <div class="van-cell__value van-field__value" style="display: flex;justify-content: space-between;align-items: center;">
            <div class="van-field__body" style="color: #323233" v-if="bankid" v-html="branch">
            </div>

            <div class="van-field__body" v-else style="color: #c8c9cc">
              {{ $t("请选择银行兑换") }}
            </div>
            <img class="w-[28rpx] h-[28rpx]"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dKhDsIwEIDha5spzHiDyckZEtzGm4wHI8Aj8ASgUIgqsMcTgCAISFdmQJB1uyuS+1XT6+UzBZAk6e9SoUE+mZfaqwqi8vZ4WG7IYFHU6SMxF/ih+9ON0a6u3/e6ZwchPuzCgqBtHzfGzSJR9AlUoaHq28yndaad2bbHDBjYab84QwzIRAcxEkhESRgZHEDJGAsMoCyMDb5R05hSeUhvI7fGXff3lyRJ+vQCnXFOgOPbmjYAAAAASUVORK5CYII="
            />
          </div>
        </div>


        <van-popup v-model="showBank" round position="bottom" :style="{ height: '320px' }" >
          <van-picker
              show-toolbar
              :columns="banks"
              @confirm="onConfirm"
              @cancel="onCancel">
            <template #confirm>
              <span>{{ $t("确定") }}</span>
            </template>
            <template #cancel>
              <span>{{ $t("取消") }}</span>
            </template>
          </van-picker>
        </van-popup>

        <div class="label" style="margin-top: 30px">{{ $t("分数") }}</div>
        <van-field v-model="withdraw_money" type="number" :placeholder="$t('转换点数')"/>

        <div class="label" style="margin-top: 30px">{{ $t("二级密码") }}</div>
        <van-field
            v-model="password"
            :type="passwordType"
            input-align="center"
            class="input"
            :placeholder="$t('请输入付款密码')">
          <template slot="right-icon">
            <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
          </template>
        </van-field>

        <van-button class="login-btn" type="default" @click="doWithdraw()">{{ $t("发送") }}</van-button>
        <div class="tipsContent">
          <p>{{ $t("注意") }}：</p>
          <div>
            <div class="u-flex u-row-between px-[40rpx] mb-[2rpx] u-font-28 h-[100rpx] bg-white">
              <div style="color: rgb(155, 164, 175);">{{ $t("账户余额") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;">{{ formatNumber(userInfo.money * 1) }}</div>
            </div>
            <div class="u-flex u-row-between px-[40rpx] mb-[2rpx] u-font-28 h-[100rpx] bg-white">
              <div style="color: rgb(155, 164, 175);">{{ $t("限制每天的次数") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;" v-if="withdrawRole.num == ''">{{ $t("无限制") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;" v-else>{{ withdrawRole.num }}</div>
            </div>
            <div class="u-flex u-row-between px-[40rpx] mb-[2rpx] u-font-28 h-[100rpx] bg-white">
              <div style="color: rgb(155, 164, 175);">{{ $t("提款时间") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;"  v-if="withdrawRole.withraw_time_start == '' && withdrawRole.withraw_time_end == ''">{{ $t("无限制") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;"  v-else>{{ withdrawRole.withraw_time_start  }} - {{ withdrawRole.withraw_time_end  }}</div>
            </div>
            <div class="u-flex u-row-between px-[40rpx] mb-[2rpx] u-font-28 h-[100rpx] bg-white">
              <div style="color: rgb(155, 164, 175);">{{ $t("每天限制金额") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;">{{ $t("无限制") }}</div>
<!--              <div style="color: rgb(42, 53, 99);text-align: right;"  v-if="withdrawRole.min == '' && withdrawRole.max == ''">{{ $t("无限制") }}</div>
              <div style="color: rgb(42, 53, 99);text-align: right;"  v-else>{{ formatNumber(withdrawRole.min)  }} - {{ formatNumber(withdrawRole.max)  }}</div>-->
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      branch: "",
      bankid: "",
      showBank:false,
      showPopover: false,
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      passwordType: "password",
      password: "",
      banks:[]
    };
  },
  methods: {

    onConfirm(value) {
      this.branch = value.text
      this.bankid = value.value
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },

    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
            for(var i = 0; i < this.bankInfo.length; i++){
              this.banks.push({
                "value": this.bankInfo[i].id,
                "text": this.bankInfo[i].branch+"<span style='margin-left: 10px'>"+this.bankInfo[i].branch_number+"</span>",
              });
            }
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money * 1;
    },
    doWithdraw() {
      if(this.bankid == ""){
        this.$toast(this.$t("请选择银行兑换"));
        return false;
      }
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("转换点数"));
        return false;
      } else {

        if (this.password.length <= 0) {
          this.$toast(this.$t("setPayPassword.opw"));
          return false;
        }
        this.$http({
          method: 'get',
          data: {money: this.withdraw_money, password: this.password, bankid:this.bankid},
          url: 'user_set_withdraw'
        }).then(res => {
          if (res.code === 200) {
            location.reload()
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(this.$t(res.msg));
          } else if (res.code === 402) {
            this.$toast(this.$t(res.msg));
            return false;
          }else if (res.code === 404) {
            this.$toast(this.$t(res.msg)+" "+(this.withdrawRole.withraw_time_start +" - "+ this.withdrawRole.withraw_time_end));
            return false;
          }
          let num = "";
          if (res.msg == "提现金额不能少于：") {
            num = this.withdrawRole.min;
          } else if (res.msg == "提现金额不能大于：") {
            num = this.withdrawRole.max;
          }

          this.$toast(this.$t("msg." + res.msg) + num);
        })
      }
    },
    withdrawInfo() {
      this.showPopover = true;
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.label{
  color: rgb(42, 53, 99);
  font-weight: 600;
  font-size: 38px;
}
.loginForm {
  margin: 0 50px;
  overflow: auto;
}

.login-btn {
  margin-top: 50px;
  width: 100%;
  height: 100px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  font-size: 34px;
  font-weight: bolder;
  border: none;
}

.van-nav-bar__title {
  font-size: 30px;
}

::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}

.van-cell {
  font-size: 35px;
  line-height: 80px;
  margin-top: 10px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.container .main {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}

.container .main .withdrawMoney {
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}

.container .main .withdrawMoney .money .moneyNumber {
  font-size: 50px;
  display: flex;
  flex-direction: row;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money .all {
  color: #d10404;
}

.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0 !important;
}

.container .main .withdrawMoney .information {
  padding-bottom: 30px;
}

.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .information .balance .number {
  color: #d10404;
}
.tipsContent {
  margin: 70px 0
}

.tipsContent p {
  margin-bottom: .75rem;
  color: #ff3900;
  font-size: 38px
}
.u-font-28 {
   font-size: 32px;
 }
.u-row-between {
  justify-content: space-between;
}
.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.px-\[40rpx\] {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.bg-white {
  background-color: #ffffff;
}
.h-\[100rpx\] {
  height: 100px;
}
.mb-\[2rpx\] {
  margin-bottom: 2px
}

.w-\[28rpx\] {
  width: 30px;
}
.h-\[28rpx\] {
  height: 30px;
}
::v-deep .van-picker__toolbar{
  height: 100px;
}
::v-deep .van-picker__cancel {
  padding: 20px 20PX;
  font-size: 32px;
}
::v-deep .van-picker__confirm {
  padding: 20px 20PX;
  font-size: 32px;
}
::v-deep .van-ellipsis{
  font-size: 32px;
}
</style>
